
const deleteModal = {
    okText: 'Delete',
    cancelText: 'Cancel',
}

const configDefault = ({title, content, okText, cancelText, ...rest}) =>{
    return {
        className: 'confirm_modal',
        width: 288,
        icon: null,
        title: title ? title : 'Confirm',
        content: content ? content : 'Bla bla bla....',
        okText: okText ? okText : 'Confirm',
        cancelText: cancelText ? cancelText : 'Cancel',
        centered: true,
        footer: (node, extra) =>{
            const {OkBtn, CancelBtn} = extra

            return(
                <>
                    <CancelBtn />
                    <OkBtn />
                </>
            )
        },
        ...rest,
    }
}

const getConfigByType = (type) =>{
    switch (type){
        case 'delete':
            return deleteModal
        default:
            return {}
    }
}

export const configConfirmModal = ({type, ...rest}) =>{
    if (type){
        return configDefault({...getConfigByType(type), ...rest})
    }

    return configDefault(rest)
}